<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `master/bank-account/${inputs.id}`
						: `master/bank-account`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_center_id" class="col-sm-3 mb-0">
						Center
					</label>
					<app-input
						id="inputs_center_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_center_id"
						@input="setCenterIdValue"
						fetch-url="master/center"
						placeholder="Center"
						list-value-field="name"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_bank_id" class="col-sm-3 mb-0">
						Bank Name
					</label>
					<app-input
						id="inputs_bank_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_bank_id"
						@input="setBankIdValue"
						fetch-url="master/bank"
						placeholder="Bank Name"
						list-value-field="bank_name"
						:required="true"
					/>
				</div>
<!-- 
				<div class="form-group row align-items-center">
					<label for="inputs_bank_branch_name" class="col-sm-3 mb-0">
						Bank Branch Name
					</label>
					<app-input
						id="inputs_bank_branch_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.bank_branch_name"
						:placeholder="'Bank Branch Name'"
						:required="true"
					/>
				</div> -->

				<div class="form-group row align-items-center">
					<label for="inputs_bank_account_name" class="col-sm-3 mb-0">
						Bank Account Name
					</label>
					<app-input
						id="inputs_bank_account_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.bank_account_name"
						:placeholder="'Bank Account Name'"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_bank_account_no" class="col-sm-3 mb-0">
						Bank Account No
					</label>
					<app-input
						id="inputs_bank_account_no"
						class="col-sm-9"
						type="number"
						v-model="inputs.bank_account_no"
						:placeholder="'Bank Account No'"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label
						for="inputs_bank_account_virtual_no"
						class="col-sm-3 mb-0"
					>
						Bank Virtual Account No
					</label>
					<app-input
						id="inputs_bank_account_virtual_no"
						class="col-sm-9"
						type="number"
						v-model="inputs.bank_account_virtual_no"
						:placeholder="'Bank Virtual Account No'"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_is_active" class="col-sm-3 mb-0">
						&nbsp;
					</label>
					<div class="col-sm-8">
						<app-input
							id="inputs_is_active"
							:list-value-field="$t('is_active')"
							type="single-checkbox"
							v-model="inputs.is_active"
						/>
					</div>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			preloader: false,
			input_bank_id: {},
			input_center_id: {},
			inputs: {},
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.input_bank_id = {
				id: response.data.bank_id?.id,
				bank_code: response.data.bank_id?.bank_code,
				bank_name: response.data.bank_id?.bank_name,
				is_active: response.data.bank_id?.is_active,
			};
			this.input_center_id = {
				id: response.data.center?.id,
				code: response.data.center?.code,
				name: response.data.center?.name,
				is_active: response.data.center?.is_active,
			};
			this.inputs.bank_id = response.data.bank_id.id;
			this.inputs.center_id = response.data.center_id;
			this.preloader = false;
		},
		setBankIdValue(data) {
			this.inputs.bank_id = this.inputs.bank_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.bank_id = data.id;
			}
		},
		setCenterIdValue(data){
			this.inputs.center_id = this.inputs.center_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.center_id = data.id;
			}
		}
	},
};
</script>
